<template>
  <MenuBar :model="menu">
    <template #end="">
      <Button
        icon="pi pi-user"
        :label="state.userId"
        @click="popup = true"
        class="p-button-text"
      ></Button>
    </template>
  </MenuBar>

  <Dialog v-model:visible="popup" modal header="Logout">
    <div class="p-grid">
      <div class="p-col-12">
        <Button
          icon="pi pi-sign-out"
          label="ออกจากระบบ"
          @click="logout"
          class="p-button-warning"
        ></Button>
        <Button
          icon="pi pi-user-minus"
          label="ตัดการเชื่อมต่อกับ Line และออกจากระบบ"
          @click="unlink"
          class="p-button-danger p-ml-2"
        ></Button>
      </div>
    </div>
  </Dialog>
</template>

<script lang="ts">
import { computed, defineComponent, ref } from "vue";
import useState from "@/store";
import liff from "@line/liff";
import usePlugin from "@/plugins";
import { useConfirm } from "primevue/useconfirm";
import { UnlinkLineRequest } from "@/types";

export default defineComponent({
  name: "MainMenu",
  setup() {
    const { onLogout, axios } = usePlugin();
    const state = useState();
    const popup = ref(false);
    const menu = computed(() => {
      let result = [
        { label: "Home", icon: "pi pi-home pi-fw", to: { name: "Home" } },
        {
          label: "Config",
          icon: "pi pi-list pi-fw",
          to: { name: "ConfigService" },
        },
      ];

      if (state.value.isAdmin !== true) {
        result = result.filter((x) => x.label !== "Config");
      }

      return result;
    });

    const confirm = useConfirm();

    const unlink = async () => {
      confirm.require({
        header: "ออกจากระบบ",
        message: "ยืนยันเพื่อตัดการเชื่อมต่อกับ Line ออกจากระบบ ?",
        acceptLabel: "ยืนยัน",
        accept: async () => {
          await axios.post("api/v1/user/unlink", {
            userId: state.value.userId,
          } as UnlinkLineRequest);

          await liff.init({ liffId: state.value.liffId });
          if (liff.isLoggedIn() === true) {
            liff.logout();
          }
          onLogout();
        },
        rejectLabel: "ยกเลิก",
      });
    };

    const logout = async () => {
      confirm.require({
        header: "ออกจากระบบ",
        message: "ยืนยันเพื่อออกจากระบบ ?",
        acceptLabel: "ยืนยัน",
        accept: async () => {
          await liff.init({ liffId: state.value.liffId });
          if (liff.isLoggedIn() === true) {
            liff.logout();
          }
          onLogout();
        },
        rejectLabel: "ยกเลิก",
      });
    };
    return { menu, state, logout, popup, unlink };
  },
});
</script>

<style></style>
